import { EOriginSource } from '../enums/EOriginSource';
import { ETolgeeDefault } from '../enums/ETolgeeDefault';

export const ORIGIN_SOURCE = [
  {
    value: EOriginSource.HR,
    label: ETolgeeDefault.ENUM_ORIGIN_SOURCE_ADMIN
  },
  {
    value: EOriginSource.PORTAL,
    label: ETolgeeDefault.ENUM_ORIGIN_SOURCE_USER
  }
];
